/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_GETVIDEONOTE,GETVIDEONOTE_RECEIVED } = constants.GetVideoNoteConstant;

export default {
    REQUEST_GETVIDEONOTE,
    GETVIDEONOTE_RECEIVED,

  requestAddVideoTag: payload => ({
    type: REQUEST_GETVIDEONOTE,
    payload
  }),
  AddVideoTagReceived: () => ({
    type: GETVIDEONOTE_RECEIVED
  }),
};
